import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 32 33"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M24.755 27.38q-3.519.03-6.982-1.783t-6.233-4.76a25 25 0 0 1-4.489-6.661q-1.718-3.714-1.718-7.428 0-.471.042-1.032.042-.56.152-1.002h7.37l1.413 6.573-3.823 3.685q1.384 2.328 2.992 4.023a16.5 16.5 0 0 0 3.602 2.874l3.768-4.038 5.818 1.503v7.87q-.416.058-.956.118t-.956.059"
    }, null, -1)
  ])))
}
export default { render: render }